export default function ChallengesSection({ onModalOpen }: { onModalOpen: () => void }) {
  const items = [
    {
      title: "Risk assessments that don't serve their purpose.",
      description:
        'Traditional assessments take 12–24 months and produce reports too complex for day-to-day use.',
      resolutionTitle: 'Always current risk information, today and tomorrow.',
      resolutionDescription:
        'Complete new assessments in under 90 days and keep them current with automatic updates. No extra cost, no delays.',
    },
    {
      title: 'Analysis that misses what matters most.',
      description:
        'Conventional approaches focus on direct asset damage, overlooking cascading effects like service disruptions and infrastructure interdependencies.',
      resolutionTitle: 'See the full picture of interconnected risks.',
      resolutionDescription:
        'Resilience Explorer® models both direct and indirect consequences, isolation, outages, disrupted supply chains, so you can act on what truly matters.',
    },
    {
      title: "Evidence that can't withstand scrutiny.",
      description:
        'When regulators or elected members ask how priorities were determined, organisations struggle to provide defensible answers.',
      resolutionTitle: 'Clearer conversations and risk understanding.',
      resolutionDescription:
        'Simple visuals and ready-to-share reports make it easier to build trust and discuss risk with communities, boards, funders, and regulators.',
    },
    {
      title: 'Understanding without a path forward.',
      description:
        'Organisations invest in risk assessment yet lack tools to test adaptation options, prioritise investments, or track progress.',
      resolutionTitle: 'See where your risk really lies.',
      resolutionDescription:
        'Spatial analysis shows which assets and communities are most impacted, so you can target action where it matters most.',
    },
  ]
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="flex mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-start gap-8 w-full">
          <div className="flex flex-col items-start gap-4 w-full">
            <h1 className="text-4xl leading-tight font-light text-brand-blue">
              The challenges you're facing,
              <br className="hidden md:block" /> and how Resilience Explorer® solves them.
            </h1>
            <h3 className="text-lg leading-relaxed text-brand-blue lg:text-xl w-full">
              Built on cascading failure methodology developed through world-leading research.
            </h3>
          </div>
          <div className="flex flex-col items-stretch w-full">
            <div className="grid grid-cols-1 md:grid-cols-2 mt-8 py-4 gap-x-12 w-full border-0 border-b-1 border-solid border-brand-navy">
              <div className="text-lg font-semibold">The challenge</div>
              <div className="text-lg font-semibold text-brand-blue">
                What you get with Resilience Explorer®
              </div>
            </div>
            {items.map((item, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 w-full border-0 border-b-1 border-solid border-brand-navy py-8"
              >
                <div className="flex gap-4 md:gap-8 items-stretch">
                  <div className="flex-1">
                    <p className="text-base font-semibold text-brand-navy">{item.title}</p>
                    <p className="text-base leading-relaxed text-text-secondary">
                      {item.description}
                    </p>
                  </div>
                  <img
                    src={`/website/long_arrow.svg`}
                    alt=""
                    className="h-auto w-24 md:w-16 rotate-90 md:rotate-0 self-center"
                  />
                </div>
                <div className="flex gap-8 md:gap-8 items-start md:items-center">
                  <div className="flex-1">
                    <p className="text-base font-semibold text-brand-blue">
                      {item.resolutionTitle}
                    </p>
                    <p className="text-base leading-relaxed text-text-secondary">
                      {item.resolutionDescription}
                    </p>
                  </div>
                  <img
                    src={`/website/circle_check.svg`}
                    alt=""
                    className="w-20 md:w-16 h-auto relative md:-top-2 self-center"
                  />
                </div>
              </div>
            ))}
          </div>
          <button
            className="px-8 py-3 my-12 text-sm font-semibold text-white no-underline transition-colors rounded bg-brand-blue border-0 cursor-pointer hover:bg-brand-navy md:block hidden"
            onClick={onModalOpen}
          >
            Resilience Explorer® in Action
          </button>
        </div>
      </div>
    </section>
  )
}
